/** @format */

import {ApolloError} from '@apollo/client';

/**
 * Сообщение неудачной мутации.
 *
 * GraphQL-ошибка несёт текст бэкенда — он уже по-русски и предназначен
 * пользователю, показываем как есть. Сетевая или протокольная ошибка несёт
 * английскую внутренность Apollo вроде «Response not successful: Received
 * status code 500» — её человеку в русском интерфейсе не показываем,
 * вместо неё отдаём словарную строку.
 */
export function apolloErrorMessage(cause: unknown, fallback: string): string {
  if (cause instanceof ApolloError && cause.graphQLErrors.length > 0) {
    return cause.message;
  }
  return fallback;
}
